import $ from 'jquery';
// Basic functions for building, showing and closing a modal

/**
 * classname: optional classname to apply to the modal-wrapper div
 * title: optional text for the modal-header div
 * content: html content for the modal-content div
 * buttons: an array of arrays - each sub array has the config info for the button - label, action
 */
function showConfirmModal(classname, title, content, buttons) {

    let $wrapper = $('#modal-wrapper');

    if ($wrapper.length === 0) {
        alert('#modal-wrapper not found');
    } else {
        $wrapper = $wrapper.first();
    }

    // The modal bit of html is reusable, so make sure to clear any previous content

    let $background = $wrapper.find('#modal-background').first();
    $background.html('');
    $background.attr('class', '');

    let $contentWrapper = $wrapper.find('#modal-content-wrapper').first();
    let $contentInner = $wrapper.find('#modal-content-inner').first();
    let $header = $wrapper.find('#modal-header').first();
    $header.html('');
    $header.attr('class', '');
    let $content = $wrapper.find('#modal-content').first();
    $content.html('');
    $content.attr('class', '');
    let $buttons = $wrapper.find('#modal-buttons').first();
    $buttons.html('');
    $buttons.attr('class', '');

    // Now, populate the modal with the supplied data

    if (classname) {
        $contentWrapper.addClass(classname);
    }

    if (title) {
        $header.html('<h2>' + title + '</h2>');
    } else {
        $header.addClass('hide');
    }

    if (content) {
        $content.html('<p>' + content + '</p>');
    } else {
        $content.addClass('hide');
    }

    if (Array.isArray(buttons)) {
        buttons.forEach(function (button) {
            // Expect to find the following elements: text, icon, click
            $buttons.append('<button type="button" onClick="' + button.click + '">' + button.text + ' ' + button.icon + '</button>');
        });
    }

    $wrapper.addClass('show');

    $('#modal-close').unbind('click');
    $('#modal-close').on('click', function(e) {
        closeModal();
        e.preventDefault();
    });

}

function closeModal() {

    $('#modal-wrapper').removeClass('show');

}
